<template>
  <BaseFilePicker
    v-bind="$attrs"
    v-on="$listeners"
    :disableClick="true"
    :styleConfig="styleConfig"
  >
    <div v-if="file === null">
      <slot/>
    </div>
    <div
      v-else
      :style="style.container"
    >
      <div :style="style.fileName">
        {{ file.name }}
      </div>
      <div :style="style.fileSize">
        {{ fileSizeWithUnit }}
      </div>
    </div>
  </BaseFilePicker>
</template>

<script>
  import BaseFilePicker from '@base/v2/base-file-picker'
  import { FontStyle, Layout } from '@js/styles'
  import { getBytesWithUnit } from '@js/str-utils'
  import { mapGetters } from 'vuex'

  export default {
    name: 'FilePickerAreaPrimary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'change-file',
    },
    components: {
      BaseFilePicker,
    },
    props: {
      vmodelValue: {
        type: File,
        required: false,
        default: null,
      },
    },
    data: function () {
      return {
        file: this.vmodelValue,
        style: {
          container: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
          },
          fileName: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.md,
            fontWeight: FontStyle.weight.lg,
          },
          fileSize: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.sm,
            fontWeight: FontStyle.weight.md,
          },
        },
        styleConfig: {
          container: {
            height: '100%',
            padding: Layout.space.md,
            width: '100%',
          },
          label: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            width: '100%',
          },
          root: {},
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.fileName,
        {
          color: this.color.dark2(),
        },
      );
      Object.assign(
        this.style.fileSize,
        {
          color: this.color.dark3(),
        },
      );

      Object.assign(
        this.styleConfig.container,
        {
          backgroundColor: this.color.shadow1(),
          border: `dashed ${this.color.dark3()}`,
          borderWidth: '1px',
          color: this.color.dark3(),
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      fileSizeWithUnit: function () {
        return this.file === null ? '0B' : getBytesWithUnit(this.file.size);
      },
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.file = newVal;
      },
    },
  };
</script>
